<template>
  <div>
    <v-card v-if="!query" class="mt-4">
      <v-card-title>
        <div class="body-2">Remarks ({{ commentsCount }})</div>
      </v-card-title>
      <v-flex v-if="!isMatchRouteExact('qClaimHeader')">
        <v-card-text>
          <form>
            <v-text-field
              data-vv-scope="newComment"
              :label="labels.comment"
              v-model="comment"
              :error-messages="errors.collect('comment')"
              v-validate="'max:255|entry|required'"
              data-vv-validate-on="change"
              data-vv-name="comment"
              :data-vv-as="labels.comment"
              :counter="255"
            ></v-text-field>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.prevent="postNewComment">
            Add Remark
            <v-icon right dark>mdi-pen</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>
      <template v-if="init === 1">
        <!-- <transition-group name="slide-y-transition" tag="div"> -->
        <div v-for="(comment, index) in comments" :key="index">
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  {{ comment.comment }}
                </v-flex>
                <v-flex xs12>
                  <v-layout align-center row wrap>
                    <div class="grey--text caption" v-if="comment.modified">
                      <span>Modified on: {{ formatDate(comment.commentDT) }}</span>
                      <span> - By: {{ comment.firstName }}, {{ comment.lastName }}</span>
                    </div>
                    <div class="grey--text caption" v-else>
                      <span>Posted on: {{ formatDate(comment.commentDT) }}</span>
                      <span> - By: {{ comment.firstName }}, {{ comment.lastName }}, {{ comment.usrId }}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="pl-2" v-if="usrId === comment.usrId && !query">
                      <v-btn text small color="primary" @click="doPromptEdit(comment)">
                        Edit
                        <v-icon right>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn text small color="red" @click="doPromptDelete(comment)">
                        Delete
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
        </div>
        <!-- </transition-group> -->
        <v-layout align-center justify-center v-if="hasMore" class="pa-3">
          <v-btn @click="doLoadMore" :loading="fetchingMore">
            Load More Comments
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </v-layout>
      </template>
      <loader
        v-else
        :height="200"
        :init="doInit"
        loadText="Loading Comments..."
        errorText="Error Fetching Comments"
        :loading="init === 0"
        :errorMsgs="initErr"
      ></loader>
    </v-card>
    <v-dialog v-model="promptEdit" width="700" @keydown.esc="promptEdit = false">
      <v-card>
        <v-card-title>
          <div class="headline">Edit Comment</div>
          <v-spacer></v-spacer>
          <v-btn text icon @click="promptEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <form>
            <v-text-field
              data-vv-scope="updateComment"
              :label="labels.comment"
              v-model="editComment"
              :error-messages="errors.collect('editComment')"
              v-validate="'max:255|entry|required'"
              data-vv-name="editComment"
              :data-vv-as="labels.comment"
              :counter="255"
            ></v-text-field>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="promptEdit = false">Cancel</v-btn>
          <v-btn color="primary" text @click.native="doUpdateComment" :loading="submitting">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptDelete" @ok="doDeleteComment">
      Are you sure you want to delete the follow comment?
      <v-alert color="grey lighten-3" :value="true">
        <span class="deleteCommentText">
          {{ editComment }}
        </span>
      </v-alert>
    </confirm>
  </div>
</template>

<script>
import { extractMessages, extractMenu } from '@/utils/extract'
import routeMixin from '@/mixins/route'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDateTime, formatDisplayDateTime2 } from '@/utils/date'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      panel: [true],
      init: 0,
      initErr: [],
      menu: {},
      labels: {
        comment: 'Remark'
      },
      comment: '',
      comments: [],
      submitting: false,
      hasMore: true,
      fetchingMore: false,
      commentsCount: 0,
      selectedComment: undefined,
      promptEdit: false,
      promptDelete: false,
      editComment: ''
    }
  },
  computed: {
    userFirstName() {
      return this.$store.state.token.firstName
    },
    userLastName() {
      return this.$store.state.token.lastName
    },
    usrId() {
      return this.$store.state.token.usrId
    }
  },
  methods: {
    async doInit() {
      this.init = 0
      this.comments = []
      const apiUrl = this.$store.state.claims.claimRegister.menu.getComments
      if (apiUrl) {
        try {
          const expand = {
            clmNo: this.$store.state.claims.claimDetail.commonInfo.clmNo,
            size: 10
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            this.menu = extractMenu(data._links)
            this.commentsCount = result.data.totalElements
            if (data.data) {
              this.comments = data.data
            }
            this.hasMore = result.data.hasNext
          }
          this.init = 1
        } catch (err) {
          this.init = 2
          this.initErr = []
          this.initErr = extractMessages(err)
        }
      } else {
        this.init = 2
        this.initErr = []
        this.initErr.push('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doLoadMore() {
      const apiUrl = this.menu.next
      if (apiUrl) {
        try {
          this.fetchingMore = true
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result
            if (data.data && data.data.length > 0) {
              this.comments.push.apply(this.comments, data.data)
              this.hasMore = result.data.hasNext
            } else {
              this.hasMore = false
            }
          }
          this.fetchingMore = false
        } catch (err) {
          this.$toast.error('Error Fetching Comments')
          this.fetchingMore = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDate(date) {
      return formatDisplayDateTime(date)
    },
    formatDate2(date) {
      return formatDisplayDateTime2(date)
    },
    postNewComment() {
      this.$validator.validateAll('newComment').then((result) => {
        if (result) {
          const apiUrl = this.$store.state.claims.claimRegister.menu.newComment
          if (apiUrl) {
            this.submitting = true
            const expand = {
              clmNo: this.$store.state.claims.claimDetail.commonInfo.clmNo
            }
            this.$http
              .post(expandURI(apiUrl, expand), { comment: this.comment })
              .then((result) => {
                if (result.data) {
                  this.comments.unshift(result.data)
                  this.commentsCount++

                  this.$toast.success('Remark saved')

                  // Reset the comment field
                  this.comment = ''
                  this.resetValidator()
                }
                this.submitting = false
              })
              .catch((err) => {
                //
                const { data } = err.response
                if (data) {
                  this.notify(data)
                }
                this.submitting = false
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptEdit(comment) {
      this.selectedComment = comment
      this.promptEdit = true
      this.editComment = comment.comment
    },
    doUpdateComment() {
      this.$validator.validateAll('updateComment').then((result) => {
        if (result) {
          const apiUrl = this.$store.state.claims.claimRegister.menu.updateComment
          if (apiUrl) {
            this.submitting = true
            const expand = {
              commentId: this.selectedComment.commentId,
              clmNo: this.$store.state.claims.claimDetail.commonInfo.clmNo
            }
            this.$http
              .post(expandURI(apiUrl, expand), { comment: this.editComment })
              .then((result) => {
                if (result.data) {
                  const index = this.comments.indexOf(this.comments.find((x) => x.commentId === this.selectedComment.commentId))
                  this.$set(this.comments, index, result.data)
                  this.$toast.success('Remark updated')

                  // Reset the comment field
                  this.editComment = ''
                  this.$validator.pause()
                  this.$nextTick(() => {
                    this.$validator.reset()
                    this.$validator.resume()
                  })
                }
                this.promptEdit = false
                this.submitting = false
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.notify(data)
                }
                this.submitting = false
              })
          } else {
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptDelete(comment) {
      this.selectedComment = comment
      this.promptDelete = true
      this.editComment = comment.comment
    },
    async doDeleteComment() {
      const apiUrl = this.$store.state.claims.claimRegister.menu.deleteComment
      if (apiUrl) {
        this.submitting = true
        try {
          const expand = {
            commentId: this.selectedComment.commentId
          }
          await this.$http.post(expandURI(apiUrl, expand))
          this.comments.splice(this.comments.indexOf(this.comments.find((x) => x.commentId === this.selectedComment.commentId)), 1)
          this.commentsCount--
          this.submitting = false
          this.$toast.success('Remark deleted')
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mounted() {
    this.doInit()
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  },
  mixins: [MessageMixin, routeMixin]
}
</script>

<style lang="scss">
.comment-error {
  max-width: 700px;
  .comment-msg {
    padding-left: 15px;
  }
}
.commentActionCol {
  display: inline-block;
}

.deleteCommentText {
  color: #666;
}
</style>
